import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface AddDisputeNoteModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onSave: (noteContent: string) => void;
  readonly disputeId: string;
}

export function AddDisputeNoteModal({
  isOpen,
  onClose,
  onSave,
  disputeId,
}: AddDisputeNoteModalProps) {
  const [noteContent, setNoteContent] = useState('');

  const handleSave = () => {
    if (noteContent.trim()) {
      onSave(noteContent);
      setNoteContent('');
      onClose();
    }
  };

  const handleCancel = () => {
    setNoteContent('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add Note</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <p className="text-sm text-muted-foreground">
            Add a note for dispute {disputeId}
          </p>

          <div className="space-y-2">
            <Label htmlFor="note-content">
              Note Content <span className="text-destructive">*</span>
            </Label>
            <Textarea
              id="note-content"
              placeholder="Enter note content..."
              value={noteContent}
              onChange={(e) => setNoteContent(e.target.value)}
              rows={6}
              className="resize-none"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button 
            onClick={handleSave}
            disabled={!noteContent.trim()}
          >
            Save Note
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
